import { TGroupedNotifications, TNotificationsResponse } from '../../types'
import { getArtistImagePath } from 'shared/utils/getArtistImagePath'

export const ghProjectAdapter =
  (groupedNotifications: TGroupedNotifications, notification: TNotificationsResponse): TGroupedNotifications => ({
    ...groupedNotifications,
    ...(notification.notification_type && notification.id && {
      [notification.notification_type]: {
        ...groupedNotifications[notification.notification_type],
        // no need to group and count
        [notification.id]: {
          ...notification,
          count: 1,
          ids: [{ id: notification.id, notification_type: notification.notification_type }],
          last_updated: new Date(notification.campaign?.created_at ?? '').getTime(),
          card: {
            title: notification.campaign?.artist?.name ?? '',
            subtitle: notification.campaign?.name ?? '',
            imagePath: getArtistImagePath(notification.campaign?.artist?.spotify_id, notification.campaign?.artist?.facebook_id, 'm'),
            zoneId: notification.campaign?.label_id ?? '',
            count: '1 Project',
          }
        }
      }
    })
  })